var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.1967 4.58521 19.7896 8.25 21.2731V15C8.25 14.5858 8.58579 14.25 9 14.25C9.41421 14.25 9.75 14.5858 9.75 15V16.5986L10.6934 15.9697C11.0412 15.7379 11.2501 15.3476 11.2501 14.9296V8.71297L9.50871 10.3203C9.20434 10.6013 8.72984 10.5823 8.44889 10.2779C8.16794 9.97357 8.18693 9.49907 8.49129 9.21812L11.4913 6.44889C11.7786 6.1837 12.2215 6.1837 12.5088 6.44889L15.5087 9.21803C15.8131 9.49898 15.8321 9.97347 15.5511 10.2778C15.2702 10.5822 14.7957 10.6012 14.4913 10.3202L12.7501 8.71297V14.9296C12.7501 15.8491 12.2905 16.7077 11.5255 17.2178L9.75 18.4014V21.7459C10.4732 21.9121 11.2263 22 12 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaling);
export default __webpack_public_path__ + "static/media/signaling.e59e5c82bbcbba4856c655148454ee25.svg";
export { ForwardRef as ReactComponent };